import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link, Navigate } from 'react-router-dom'; // Import Link
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, withStyles, Box, Button, Container, CircularProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WaterSvg from '../assets/images/waterdrop.svg';
import AddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Clear';
import CheckCircle from '@material-ui/icons/CheckCircle';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(5),
        padding: theme.spacing(3),
        borderRadius: theme.spacing(2), 
        boxShadow: theme.shadows[5], // Add a subtle drop shadow
    },
    date: {
        marginBottom: theme.spacing(2),
    },
    counter: {
        fontSize: '3rem',
        fontWeight: 'bold',
        margin: theme.spacing(2, 0),
        color: theme.palette.primary.main, 
    },
    button: {
        marginTop: theme.spacing(2),
    },
    svg: {
        width: '150px', 
        height: '150px',
        marginBottom: theme.spacing(3),
    },
    progress: {
        color: theme.palette.secondary.main, // Customize the progress color
    },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontWeight: 'bold',
      textAlign: 'center', // Center header text
  },
  body: {
      fontSize: 14,
      textAlign: 'center', // Center body text
  },
}))(TableCell);

const Water = () => {
    const classes = useStyles();
    const { id } = useParams();

    let data = JSON.parse(localStorage.getItem("data"));
    data = data ?? {};
    data.water = data.water ?? {};
    const date_today = new Date();
    const today = date_today.toISOString().split('T')[0];
    const [waterToday, setWaterToday] = useState(data?.water[today] || 0);
    const [loading, setLoading] = useState(false); 

    const handleAddClick = () => {
        setLoading(true); // Show loading indicator
        setTimeout(() => {
            setWaterToday(waterToday + 1);
            data.water[today] = waterToday + 1;
            localStorage.setItem("data", JSON.stringify(data));
            setLoading(false); // Hide loading indicator
        }, 250);
    };

    if (id === 'today' || id === today) {
        return (
            <Container className={classes.root}>
                <img src={WaterSvg} className={classes.svg} alt="Water" />
                <Typography variant="h6" className={classes.date}>
                    {today}
                </Typography>
                <Typography variant="h4" className={classes.counter}>
                    {waterToday} Glasses
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    startIcon={loading ? <CircularProgress size={24} className={classes.progress} /> : <AddIcon />}
                    onClick={handleAddClick}
                    disabled={loading} // Disable button while loading
                >
                    {loading ? 'Adding...' : 'Add'} 
                </Button>
            </Container>
        );
    }

    if (id) {
      const waterPrevDate = data?.water[id];
      if (!waterPrevDate) {
        // redirect to /water
        return <Navigate to='/water' />
      }
      return (
        <Container className={classes.root}>
            <img src={WaterSvg} className={classes.svg} alt="Water" />
            <Typography variant="h6" className={classes.date}>
                {today}
            </Typography>
            <Typography variant="h4" className={classes.counter}>
                {waterPrevDate} Glasses
            </Typography>
            <Button
                variant="contained"
                color="primary"
                disabled={true}
                className={classes.button}
                startIcon={loading ? <CircularProgress size={24} className={classes.progress} /> : <AddIcon />}
            >
                {loading ? 'Adding...' : 'Add'} 
            </Button>
        </Container>
      );
    }

    return (
      <Box display="flex" flexDirection="column" alignItems="center"> 
          <Typography variant="h6" gutterBottom align="center"> 
              Water History
          </Typography>
          <TableContainer component={Paper} elevation={3}>
              <Table>
                  <TableHead>
                      <TableRow>
                          <StyledTableCell>Date</StyledTableCell>
                          <StyledTableCell>Number of Glasses</StyledTableCell> 
                          <StyledTableCell>Status</StyledTableCell> 
                      </TableRow>
                  </TableHead>
                  <TableBody>
                        {Object.entries(data.water).map(([date, glasses]) => (
                            <TableRow key={date}>
                                <StyledTableCell component="th" scope="row">
                                    <Link to={`/water/${date}`}>{date}</Link>
                                </StyledTableCell>
                                <StyledTableCell>{glasses}</StyledTableCell>
                                <StyledTableCell>
                                    {glasses >= 8 ? (
                                        <CheckCircle style={{ color: 'green' }} />
                                    ) : (
                                        <ClearIcon style={{ color: 'red' }} />
                                    )}
                                </StyledTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
              </Table>
          </TableContainer>
      </Box>
  );
};

export default Water;
